var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M766 4419 c-235 -39 -421 -208 -480 -436 -14 -54 -16 -198 -16 -1210 0 -1264 -3 -1199 62 -1333 48 -99 162 -209 269 -259 46 -22 111 -44 143 -50 39 -7 284 -11 703 -11 l643 0 -80 -160 -80 -160 -238 0 c-227 0 -239 -1 -276 -23 -109 -61 -106 -221 5 -277 37 -20 64 -20 1139 -20 1075 0 1102 0 1139 20 113 57 113 223 0 280 -35 18 -59 20 -274 20 l-235 0 -80 160 -80 160 647 0 c713 0 723 1 849 61 94 45 218 168 262 259 65 134 62 70 62 1330 0 1271 3 1209 -67 1344 -49 93 -156 202 -244 245 -145 71 20 65 -1949 67 -976 1 -1797 -2 -1824 -7z m3571 -324 c68 -20 126 -65 160 -122 l28 -48 3 -1138 2 -1138 -21 -50 c-13 -29 -40 -66 -66 -89 -86 -76 65 -70 -1883 -70 -1940 0 -1795 -5 -1880 67 -24 21 -53 60 -66 87 l-24 51 0 1131 0 1132 28 52 c33 64 83 107 154 131 51 17 133 18 1784 19 1505 0 1737 -2 1781 -15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.0deb9a64896c544297a277e515d5f1ac.svg";
export { ForwardRef as ReactComponent };